export default "__VITE_ASSET__88b82dda__"